module.exports = __webpack_public_path__ + "img/bizdetail.8d63138b.png";